import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=4b4582e6&scoped=true&"
import script from "./UserVerification.vue?vue&type=script&lang=ts&"
export * from "./UserVerification.vue?vue&type=script&lang=ts&"
import style0 from "./UserVerification.vue?vue&type=style&index=0&id=4b4582e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4582e6",
  null
  
)

export default component.exports